import { gql } from "@apollo/client";

export const GET_ADICIONALES_RESUMEN = gql`
query RequerimientosAdicionales (
    $idDatosGenerales: Int!
) {
    adicionalRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        idComboRIValorReqAdicionalNavigation{
            valor
        }
    }
}`;